import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SEGMENTOS_CRM, SegmentoCrm} from '../crm-segmentos';

export interface ResumoSegmentoCrm {
  status: string;
  qtde: number;
  qtdeRecebeMensagem: number;
  gasto90d: number;
  pedidos90d: number;
}

interface ItemFaixa extends SegmentoCrm {
  qtde: number;
  pct: number;
}

/** Saúde da base: barra empilhada por segmento e um bloco clicável por segmento. */
@Component({
  selector: 'app-faixa-segmentos-crm',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faixa-segmentos-crm.component.html',
  styleUrls: ['./faixa-segmentos-crm.component.scss']
})
export class FaixaSegmentosCrmComponent {
  @Input() resumo: ResumoSegmentoCrm[] = [];
  @Input() selecionado: string = null;
  @Input() carregando = false;
  @Output() selecione = new EventEmitter<string>();

  get total(): number {
    return (this.resumo || []).reduce((soma, linha) => soma + (Number(linha.qtde) || 0), 0);
  }

  get itens(): ItemFaixa[] {
    const total = this.total;
    return SEGMENTOS_CRM.map(segmento => {
      const linha = (this.resumo || []).find(l => l.status === segmento.codigo);
      const qtde = linha ? Number(linha.qtde) || 0 : 0;
      return {...segmento, qtde, pct: total ? Math.round(qtde / total * 100) : 0};
    });
  }

  /** Barra na ordem da jornada (bons → risco → fora), não na ordem de ação. */
  get fatias(): ItemFaixa[] {
    const ordem = ['CAMPEAO', 'FIEL', 'NOVO', 'ESFRIANDO', 'SUMIDO', 'PERDIDO', 'SEM_PEDIDO'];
    return this.itens.filter(item => item.qtde > 0).sort((a, b) => ordem.indexOf(a.codigo) - ordem.indexOf(b.codigo));
  }

  get pctEmDia(): number {
    return this.somaPct(['CAMPEAO', 'FIEL', 'NOVO']);
  }

  get pctAtencao(): number {
    return this.somaPct(['ESFRIANDO', 'SUMIDO']);
  }

  numero(valor: number): string {
    return (Number(valor) || 0).toLocaleString('pt-BR');
  }

  private somaPct(codigos: string[]): number {
    const total = this.total;
    if (!total) return 0;
    const soma = this.itens.filter(item => codigos.indexOf(item.codigo) !== -1).reduce((s, item) => s + item.qtde, 0);
    return Math.round(soma / total * 100);
  }
}
